import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibLocaleModule } from '@lxlib/theme';
import { LxlibUtilModule } from '@lxlib/util';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TagSelectComponent } from './tag-select.component';

const COMPONENTS = [TagSelectComponent];

@NgModule({
  imports: [CommonModule, NzIconModule, LxlibLocaleModule, LxlibUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class TagSelectModule {}
